export var AutoRoutingAssignmentStatus;
(function (AutoRoutingAssignmentStatus) {
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["PENDING"] = 0] = "PENDING";
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["STREAM_TIMEOUT"] = 10] = "STREAM_TIMEOUT";
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["USER_ACCEPTED"] = 20] = "USER_ACCEPTED";
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["USER_DECLINED"] = 21] = "USER_DECLINED";
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["USER_TIMEOUT"] = 22] = "USER_TIMEOUT";
    AutoRoutingAssignmentStatus[AutoRoutingAssignmentStatus["USER_ACCEPTED_BUT_ALREADY_HANDLED"] = 30] = "USER_ACCEPTED_BUT_ALREADY_HANDLED";
})(AutoRoutingAssignmentStatus || (AutoRoutingAssignmentStatus = {}));
//# sourceMappingURL=auto-routing-assignment-status.enum.js.map